module.exports = __webpack_public_path__ + "img/Clipchamp-icon.0fa0b0dc.png";